import Vue from 'vue';
import ExportPdfButton from '@/components/ExportPdfButton.vue';

let autoIdCounter = 1;

/**
 * Auto-inject ExportPdfButton near tables for quick PDF export.
 * - Avoid duplicates by marking processed tables with data-auto-pdf-injected
 * - Pass showTotals: true by default
 * - Export only the first table in scope (handled by PdfTableExporter)
 * @param {Element} rootEl
 * @param {Vue} vmCtx
 */
function injectPdfButtons(rootEl, vmCtx) {
  if (!rootEl || !rootEl.querySelectorAll) return;

  // Standalone tables (not inside .card) — keep logic minimal and reliable
  const standaloneTables = Array.from(rootEl.querySelectorAll('table, .vue-good-table table, .vgt-table'))
    .filter(tbl => !tbl.closest('.card'));

  standaloneTables.forEach((tbl) => {
    if (tbl.hasAttribute('data-auto-pdf-injected')) return;
    if (!tbl.id) tbl.id = `auto_export_pdf_table_${Date.now()}_${autoIdCounter++}`;
    const selectors = [`#${tbl.id}`];

    // Reuse or create toolbar before the table
    const parent = tbl.parentNode;
    let bar = null;
    if (parent && parent.querySelector) bar = parent.querySelector(':scope > [data-export-toolbar]');
    if (!bar) {
      bar = document.createElement('div');
      bar.setAttribute('data-export-toolbar', '');
      bar.className = 'export-actions d-flex justify-content-end mb-2';
      if (parent && parent.insertBefore) parent.insertBefore(bar, tbl);
    }

    // Only one PDF button per toolbar
    if (!bar.querySelector('[data-role="pdf-button"]')) {
      const BtnCtor = Vue.extend(ExportPdfButton);
      const routePath = (vmCtx && vmCtx.$route && vmCtx.$route.path)
        ? vmCtx.$route.path.replace(/[\/#]+/g, '-').replace(/^-+|-+$/g, '')
        : 'report';
      // The button's title doubles as the exported report heading, so derive a
      // readable report name ("view-invoices" → "View Invoices") instead of
      // stamping "Export to PDF" on the customer-facing document.
      const reportTitle = routePath
        .split('-')
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ') || 'Report';
      const vm = new BtnCtor({ propsData: { selectors, title: reportTitle, filename: `${routePath}.pdf`, label: 'PDF', showTotals: true } });
      vm.$mount();
      vm.$el.setAttribute('data-role', 'pdf-button');
      bar.appendChild(vm.$el);
    }

    tbl.setAttribute('data-auto-pdf-injected', '');
  });
}

Vue.mixin({
  mounted() { this.$nextTick(() => injectPdfButtons(this.$el || document.body, this)); },
  updated() { this.$nextTick(() => injectPdfButtons(this.$el || document.body, this)); }
});
